import { getDeviceType } from 'growthbook/utils/device-data'
import { useTranslations } from 'next-intl'

export function LastUsedMarker() {
  const t = useTranslations()

  const deviceType = getDeviceType()
  if (deviceType !== 'desktop') {
    return null
  }

  return (
    <div className="absolute left-[calc(100%+4px)] flex items-center">
      <span className="h-0 w-0 border-b-[4px] border-r-[4px] border-t-[4px] border-b-transparent border-r-[#131315] border-t-transparent" />
      <span className="text-11 text-nowrap rounded bg-[#131315] px-[6px] py-1 normal-case text-[#FFFFFF]">
        {t('last_used_marker')}
      </span>
    </div>
  )
}
